//Componentes generales
import React, { useState, useEffect } from "react";
import moment from "moment";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faBox,
  faRotateRight,
  faFilePdf,
  faDownload,
  faPen,
  faRectangleXmark,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";

//Estilos
import "./SoliInfo.css";
import { EDITA_NOTAS_PRIVADAS_SOLICITUD } from "../../utils/permisos";

function SoliInfo({
  item = {},
  files,
  cerrar,
  abrirURL,
  guardarModificaciones,
  usuario,
}) {
  //state de solicitud.
  const [solicitud, setSolicitud] = useState(item);
  //state para edición de nota.
  const [editNota, setEditNota] = useState(false);
  //state para edición de nota privada.
  const [editNotaReservada, setEditNotaReservada] = useState(false);

  /*
        Disparador que se activa al detectar algun cambio en el item. Setea la solicitud con el item que fue modificado.
    */
  useEffect(() => {
    setSolicitud(item);
  }, [item]);

  /*
        Manejador que descargar/abre todos los archivos adjuntados a la solicitud. 
    */
  const handleDownloadAll = () => {
    files.map((file) => abrirURL(file.url));
  };

  /* 
        Manejador que determina si habilitar o no la edición del campo Nota.
    */
  const handleEditNota = () => {
    setEditNota(!editNota);
  };

  /* 
        Manejador que determina si habilitar o no la edición del campo Nota Reservada.
    */
  const handleEditNotaReservada = () => {
    setEditNotaReservada(!editNotaReservada);
  };

  /* 
        Manejador ante cambio en casilla de Nota.
            Donde valor es lo ingresado por el usuario.
    */
  const handleModificaNota = (valor) => {
    setSolicitud({ ...solicitud, notePubl: valor });
  };

  /* 
        Manejador ante cambio en casilla de Nota Reservada.
            Donde valor es lo ingresado por el usuario.
    */
  const handleModificaNotaReservada = (valor) => {
    setSolicitud({ ...solicitud, notePriv: valor });
  };

  const saveChangesNota = async (valor) => {
    setEditNota(false);

    const obj = { notePubl: solicitud.notePubl };
    const resp = await guardarModificaciones(solicitud, obj);
    setSolicitud(resp.data);
  };

  /* 
        Guarda la solicitud mediante función del context.
    */
  const saveChangesNotaReservada = async (valor) => {
    setEditNotaReservada(false);

    const obj = { notePriv: solicitud.notePriv };
    const resp = await guardarModificaciones(solicitud, obj);
    setSolicitud(resp.data);
  };

  return (
    <div className="container-gr-req">
      <div className="container-r-list-item-header-info">
        <div className="r-list-item-header-title">
          {item.soliAjusCodFor + " - " + item.soliAjusNroFor}
        </div>
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          icon={faXmark}
          onClick={() => cerrar(null)}
        />
      </div>
      <div className="container-r-item-details">
        <div className="container-r-info-items">
          <div className="container-r-info-p">
            <div className="label-req-title">Estado Actual </div>
            <div className="r-list-item-details-clave-v">{solicitud.state}</div>
            <div className="label-req-title">Proveedor </div>
            <div className="r-list-item-details-title-v">
              {solicitud.user[0].fullName}
            </div>
          </div>
        </div>
        <div className="container-r-item-title-details">Fecha</div>
        <div className="container-r-fecha">
          <div className="label-req-fecha">
            <div className="r-list-item-details-data-v">Alta </div>
            <div className="r-list-item-details-fecha-v">
              {moment(item.fecAlt).format("DD-MM-YYYY")}
            </div>
          </div>
        </div>
        <div className="container-r-item-title-details">
          <div>Nota Proveedor</div>
          {!editNota && (
            <div className="container-button-download">
              {!editNotaReservada && (
                <button className="button-edit" onClick={handleEditNota}>
                  <FontAwesomeIcon icon={faPen} />{" "}
                </button>
              )}
            </div>
          )}
          {editNota && (
            <div className="container-button-download">
              <button className="button-edit" onClick={handleEditNota}>
                <FontAwesomeIcon icon={faRectangleXmark} />
              </button>
              <button className="button-edit" onClick={saveChangesNota}>
                <FontAwesomeIcon icon={faFloppyDisk} />
              </button>
            </div>
          )}
        </div>
        <div className="container-r-texto">
          {!editNota && (
            <div className="r-list-item-details-data-v">
              {solicitud.notePubl}
            </div>
          )}
          {editNota && (
            <textarea
              className="r-textarea-input"
              value={solicitud.notePubl}
              onChange={(data) => handleModificaNota(data.target.value)}
            />
          )}
        </div>
        <>
          <div className="container-r-item-title-details">
            <div>Nota Administración</div>
            {!editNotaReservada &&
              usuario.userType.some((item) =>
                EDITA_NOTAS_PRIVADAS_SOLICITUD.includes(item.typeName)
              ) && (
                <div className="container-button-download">
                  {!editNota && (
                    <button
                      className="button-edit"
                      onClick={handleEditNotaReservada}
                    >
                      <FontAwesomeIcon icon={faPen} />{" "}
                    </button>
                  )}
                </div>
              )}
            {editNotaReservada &&
              usuario.userType.some((item) =>
                EDITA_NOTAS_PRIVADAS_SOLICITUD.includes(item.typeName)
              ) && (
                <div className="container-button-download">
                  <button
                    className="button-edit"
                    onClick={handleEditNotaReservada}
                  >
                    <FontAwesomeIcon icon={faRectangleXmark} />
                  </button>
                  <button
                    className="button-edit"
                    onClick={saveChangesNotaReservada}
                  >
                    <FontAwesomeIcon icon={faFloppyDisk} />
                  </button>
                </div>
              )}
          </div>
          <div className="container-r-texto">
            {!editNotaReservada && (
              <div className="r-list-item-details-data-v">
                {solicitud.notePriv}
              </div>
            )}
            {editNotaReservada && (
              <textarea
                className="r-textarea-input"
                value={solicitud.notePriv}
                onChange={(data) =>
                  handleModificaNotaReservada(data.target.value)
                }
              />
            )}
          </div>
        </>
        {files.length > 0 && (
          <>
            <div className="container-r-item-title-details">
              <div>Archivos</div>
              <div className="container-button-download">
                <button className="button-download" onClick={handleDownloadAll}>
                  Descargar Todos <FontAwesomeIcon icon={faDownload} />{" "}
                </button>
              </div>
            </div>
            <div className="container-files-rq">
              <ul className="container-files-rq-details">
                {files.map((file) => (
                  <li
                    className="container-files-rq-details-items"
                    key={file.name}
                    onClick={() => abrirURL(file.url)}
                  >
                    {file.name}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SoliInfo;